import { Reducer } from 'redux';

// Keeps the lists in the state usable by the tables whatever the API returns: an error response
// (e.g. {"message": ...} after a 500) stored where a list is expected breaks the page with
// "x.map is not a function", and as the state is persisted it keeps breaking it after reloads.
//
// - keys that are arrays in the initial state are always arrays
// - extraListKeys (lists that start as null/undefined, meaning not loaded yet) are arrays, null or undefined
// anything else becomes an empty list
export const listSanitizer = (initialState: Record<string, any>, extraListKeys: string[] = []) => {
	const alwaysArrayKeys = Object.keys(initialState).filter((key) => Array.isArray(initialState[key]));
	const nullableListKeys = extraListKeys.filter((key) => !alwaysArrayKeys.includes(key));

	return <S extends Record<string, any>>(state: S): S => {
		if (!state) return state;
		let fixed: S | null = null;
		const fix = (key: string) => {
			console.warn(`State "${key}" is not a list, replaced with an empty one`, state[key]);
			fixed = fixed ?? { ...state };
			(fixed as Record<string, any>)[key] = [];
		};
		alwaysArrayKeys.forEach((key) => {
			if (!Array.isArray(state[key])) fix(key);
		});
		nullableListKeys.forEach((key) => {
			if (state[key] != null && !Array.isArray(state[key])) fix(key);
		});
		return fixed ?? state;
	};
};

// runs on every action; the persisted state is checked separately when it's restored (see stores/store.js)
export const guardListKeys = <S extends Record<string, any>>(reducer: Reducer<S>, sanitize: (state: S) => S): Reducer<S> =>
	(state, action) => sanitize(reducer(state, action));
